import { ProfileType } from 'features/MyProfile/types'

export const formatUserName = (profile: ProfileType) => {
  const displayName = `${profile?.firstName || ''} ${profile?.lastName || ''}`
  return profile?.displayName ?? displayName
}
